export function waitScrollEnd() {
  return new Promise(resolve => {
    let scrollingTimeout: number;

    const checkScrollStatus = () => {
      clearTimeout(scrollingTimeout);
      scrollingTimeout = window.setTimeout(() => {
        document.removeEventListener('scroll', checkScrollStatus);
        resolve(true);
      }, 150);
    };

    document.addEventListener('scroll', checkScrollStatus);
    checkScrollStatus();
  });
}
